<div>

    <div class="container">
        <h1 style="text-align:center">{{ 'Tornei amatoriali' | translate }}</h1>

        <div class="img-top">
            <img src="assets/img/golf.jpg" />
        </div>

        <ng-container *ngIf="app.curruser && app.curruser.C4">

            <!-- <div class="logo">
            <img *ngIf="store" [src]="utils.imageLogo(store)" />
        </div> -->

            <div class="biglietto mt-20 p-30">

                <div class="row px-20 my-20">

                    <div class="col-12 col-sm-6 mb-20" style="line-height: 2;" *ngIf="app.curruser">
                        <h5 class="mb-30">Contatti</h5>
                        <div>{{ app.curruser.company }}</div>
                        <div>
                            {{ app.curruser.address }}{{ ', ' + app.curruser.city }}{{ ' (' + app.curruser.province + ')' }}{{ ' - ' + app.curruser.zip }}
                        </div>
                        <div>Web: <a [href]="'https://' + app.curruser.website">{{ app.curruser.website }}</a></div>
                        <div>Email: {{ app.curruser.email }}</div>
                        <div>Telefono: {{ app.curruser.phone }}</div>
                    </div>

                    <div class="col-12 col-sm-6">
                        <h5 class="mb-30">Richiedi partecipazione</h5>

                        <mat-form-field class="full-width" style="max-width: 400px">
                            <mat-label>Nome Cognome *</mat-label>
                            <input matInput [(ngModel)]="prenotaNome" (change)="checkForm()">
                        </mat-form-field>
                        <div class="row">
                            <div class="col-sm-6" style="max-width: 200px">
                                <mat-form-field class="full-width" style="max-width: 400px">
                                    <mat-label>Email *</mat-label>
                                    <input matInput [(ngModel)]="prenotaEmail" (change)="checkForm()">
                                </mat-form-field>
                            </div>
                            <div class="col-sm-6" style="max-width: 200px">
                                <mat-form-field class="full-width" style="max-width: 400px">
                                    <mat-label>Cellulare *</mat-label>
                                    <input matInput [(ngModel)]="prenotaMobile" (change)="checkForm()">
                                </mat-form-field>
                            </div>
                        </div>
                        <mat-form-field class="full-width" style="max-width: 400px">
                            <mat-label>Nome del Torneo *</mat-label>
                            <input matInput [(ngModel)]="prenotaTorneo" (change)="checkForm()">
                        </mat-form-field>

                        <mat-form-field class="full-width" style="max-width: 400px">
                            <mat-label>Messaggio</mat-label>
                            <textarea matInput [(ngModel)]="prenotaMsg" (change)="checkForm()" style="min-height: 60px;"></textarea>
                        </mat-form-field>

                        <re-captcha #recaptcha (resolved)="resolved($event)" siteKey="6Le7lvYhAAAAAMeOWm5GTZmchc_lsdum6kZvYnkv">
                        </re-captcha>

                        <mat-checkbox class="mt-20 mb-10" [(ngModel)]="privacy" color="primary" (change)="checkForm()" style="font-size: .9rem">
                            {{ 'login.privacy1' | translate }}
                            <span class="link" (click)="openUrl('')">{{ 'login.privacy' | translate }}</span> {{ 'login.privacy2' | translate }}
                        </mat-checkbox>

                        <div class="mt-15" style="width: 100%; display: flex; flex-direction: column;">
                            <div class="mb-5" *ngIf="errorMessage" style="color: red;">{{ errorMessage }}</div>
                            <button style="width: 100px;" mat-button class="container-buy-button shop-button shop-button-label" (click)="invia()">
                <span class="shop-button-label">{{ 'Invia' | translate }}</span>
              </button>
                        </div>

                    </div>
                </div>

            </div>
        </ng-container>
        <ng-container *ngIf="app.curruser && app.curruser.C4">

        </ng-container>

        <app-credits [configApp]="app" *ngIf="app"></app-credits>


    </div>

</div>